import _filter from 'lodash/filter';
import _find from 'lodash/find';
import _get from 'lodash/get';
import _map from 'lodash/map';

import { MEDIA_CATEGORY_UNSPECIFIED } from 'components/modules/business-profile/constants/media';

export function filterOutByAssociations(fileMetadata, associations) {
  return fileMetadata.filter(
    (metadata) => !associations.includes(_get(metadata, 'metadata.locationAssociationCategory')),
  );
}

export function keepByAssociations(fileMetadata, associations) {
  return fileMetadata.filter((metadata) =>
    associations.includes(_get(metadata, 'metadata.locationAssociationCategory')),
  );
}

export function createFileProviderMetadataPayload(
  locationId,
  providerSettingId,
  file,
  { association = MEDIA_CATEGORY_UNSPECIFIED } = {},
) {
  const fileId = _get(file, 'id', null);
  const fileDescription = _get(file, 'description', null);

  return {
    providerSetting: providerSettingId,
    location: locationId,
    businessFile: fileId,
    metadata: {
      locationAssociationCategory: association,
      description: fileDescription,
    },
  };
}

export function getFileProviderMetadata(fileId, filesMetadata) {
  return _find(filesMetadata, (file) => file.businessFile === fileId);
}

export function getFilesByAssociations(files, filesMetadata, associations) {
  const filteredFilesMetadata = keepByAssociations(filesMetadata, associations);

  const fileIds = _map(filteredFilesMetadata, 'businessFile');

  return _filter(files, (file) => fileIds.includes(file.id));
}

export function getFileByAssociations(files, filesMetadata, associations) {
  const filteredFiles = getFilesByAssociations(files, filesMetadata, associations);

  return _get(filteredFiles, '[0]', null);
}
